export enum types {
  ORDERS_GET_UNAPPROVED = 'orders/getUnapproved',
  ORDERS_GET_PENDING = 'orders/getPending',
  ORDERS_CHANGE_PAGE = 'orders/changePage',
  ORDERS_SET_FILTER = 'orders/setFilter',
  ORDERS_SET_DATE_FILTER = 'orders/setDateFilter',
}
